/**
 * Menangkap `?ref=AGEN-XXXX` di HALAMAN MANA PUN, lalu menyimpannya.
 *
 * Tautan referral yang dibagikan agen mendarat di beranda, bukan di checkout.
 * Tanpa penangkap global ini, kode referral hilang begitu pengunjung menekan
 * tombol apa pun, dan agen melihat "Belum ada referral" selamanya meski
 * penjualannya nyata — persis keluhan yang akan sampai sebagai tuduhan komisi
 * tidak dibayar.
 *
 * Sengaja global dan sengaja tidak mengalihkan halaman: menyimpan diam-diam
 * lebih baik daripada menulis ulang URL yang sedang dibaca pengunjung.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (!import.meta.client) return
  const ref = to.query.ref
  if (typeof ref === 'string' && ref.trim()) simpanRef(ref)
})
